import { atom } from "nanostores"

import { Pool } from "../api/pools-api"
import { PoolOverview } from "@/types"

export const $poolsOverviewMap = atom<Record<string, PoolOverview> | null>(null)
export const $poolsOverviewFull = atom<boolean>(false)
export const $allPools = atom<Pool[]>([])

/**
 * Gets a random microDexi process ID for the specified pool
 * @param poolId The ID of the pool
 * @param options Optional configuration
 * @returns A random microDexi process ID or undefined if none exists
 */
export function getMicroDexi(
  poolId: string,
  options?: { enableLogging?: boolean },
): string | undefined {
  const poolsMap = $poolsOverviewMap.get()

  // Guard against missing data
  if (!poolsMap || !poolId) {
    return undefined
  }

  const poolOverview = poolsMap[poolId]

  // Check if pool exists and has microDexi process IDs
  if (!poolOverview?.microdexi_process_ids?.length) {
    return undefined
  }

  // Get random microDexi process ID
  const processIds = Array.isArray(poolOverview.microdexi_process_ids)
    ? poolOverview.microdexi_process_ids
    : [poolOverview.microdexi_process_ids]

  const randomIndex = Math.floor(Math.random() * processIds.length)
  const selectedProcessId = processIds[randomIndex]

  // Only log if logging is explicitly enabled
  if (options?.enableLogging) {
    console.log("Selected microDexi process:", selectedProcessId)
  }

  return selectedProcessId
}
